export default "__VITE_ASSET__8q5aMH0a__"